import React, { useEffect, useState } from "react";
import { useUser } from "../hooks/useUser";
import Uppy from "@uppy/core";
import Dashboard from "@uppy/dashboard";
import RemoteSources from "@uppy/google-drive";
import ImageEditor from "@uppy/image-editor";
import Webcam from "@uppy/webcam";
import Tus from "@uppy/tus";
import supabase from "../supabaseClient";
import "../styles/global.css";
import "../styles/Trees.css";
import "@uppy/core/dist/style.min.css";
import "@uppy/dashboard/dist/style.min.css";
import "@uppy/webcam/dist/style.min.css";
import "@uppy/image-editor/dist/style.min.css";

function Test() {
  const { user, loading } = useUser();
  const [photos, setPhotos] = useState([]);

  // Supabase-specific keys and project information
  const SUPABASE_ANON_KEY =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZreGduaGNja2ptZ3BudWJlcHd1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzExOTczNTIsImV4cCI6MjA0Njc3MzM1Mn0.wg0z0anhQ3xYe2A8oNIVDfUlwCTWJbFKMCg8bgU4cN4";

  const SUPABASE_PROJECT_ID = "vkxgnhcckjmgpnubepwu";
  const STORAGE_BUCKET = "avatars";
  const BEARER_TOKEN =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZreGduaGNja2ptZ3BudWJlcHd1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzExOTczNTIsImV4cCI6MjA0Njc3MzM1Mn0.wg0z0anhQ3xYe2A8oNIVDfUlwCTWJbFKMCg8bgU4cN4";
  const folder = "";
  const supabaseStorageURL = `https://${SUPABASE_PROJECT_ID}.supabase.co/storage/v1/upload/resumable`;

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const { data: files, error } = await supabase.storage
          .from("avatars")
          .list(); // No folder path specified here, assuming files are at the root level
        console.log(files);

        if (error) {
          console.error("Error listing files:", error.message);
          return;
        }

        if (!files || files.length === 0) {
          console.warn("No files found in the bucket.");
          return;
        }

        const photoUrls = [];
        for (const file of files) {
          const { data, error: urlError } = await supabase.storage
            .from("avatars")
            .getPublicUrl(file.name); // Access file directly by its name
          console.log(data);

          if (urlError) {
            console.error("Error fetching photo URL:", urlError.message);
          } else if (data.publicUrl) {
            photoUrls.push(data.publicUrl);
          }
        }

        setPhotos(photoUrls);
      } catch (err) {
        console.error("Error fetching photos:", err.message);
      }
    };

    fetchPhotos();
  }, []);

  useEffect(() => {
    const uppy = new Uppy()
      .use(Dashboard, {
        inline: true,
        limit: 10,
        target: ".DashboardContainer",
        showProgressDetails: true,
      })
      .use(RemoteSources, { companionUrl: "https://companion.uppy.io" })
      .use(Webcam, { target: Dashboard })
      .use(ImageEditor, { target: Dashboard })
      .use(Tus, {
        endpoint: supabaseStorageURL,
        headers: {
          authorization: `Bearer ${BEARER_TOKEN}`,
          apikey: SUPABASE_ANON_KEY,
        },
        uploadDataDuringCreation: true,
        chunkSize: 6 * 1024 * 1024,
        allowedMetaFields: [
          "bucketName",
          "objectName",
          "contentType",
          "cacheControl",
        ],
        onError: function (error) {
          console.log("Failed because: " + error);
        },
      });

    uppy.on("file-added", (file) => {
      const supabaseMetadata = {
        bucketName: STORAGE_BUCKET,
        objectName: folder ? `${folder}/${file.name}` : file.name,
        contentType: file.type,
      };

      file.meta = {
        ...file.meta,
        ...supabaseMetadata,
      };

      console.log("file added", file);
    });

    uppy.on("complete", (result) => {
      console.log(
        "Upload complete! We’ve uploaded these files:",
        result.successful
      );
    });

    return () => uppy.close(); // Cleanup on component unmount
  }, []);

  return (
    <div>
      <h1>Upload images</h1>
      <div className="DashboardContainer" />
      <div className="gallery-container">
        <div className="photo-gallery">
          {photos.map((url, index) => (
            <img key={index} src={url} alt={`Uploaded image ${index + 1}`} />
          ))}
        </div>
      </div>
      <p>User: {user?.name || "Guest"}</p>
    </div>
  );
}

export default Test;
